import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { warehouseOptionsQueryOptions } from '../../../features/inventory/queries'
import { newTransferSearchSchema } from '../../../features/inventory/search'
import { NewStockTransferPage } from '../../../features/inventory/stock-transfer-pages'

export const Route = createFileRoute('/_app/stock-transfers/new')({
  staticData: { crumb: 'stockTransferNew' },
  validateSearch: newTransferSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.transfer'),
  loader: ({ context }) => {
    // Warm the warehouse pickers; the form does not wait.
    void context.queryClient.prefetchQuery(warehouseOptionsQueryOptions)
  },
  component: NewStockTransferPage,
})
